module.exports = __webpack_public_path__ + "static/img/policy-manual-wizard-icon-and-name.6c8145c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/policy-manual-wizard-icon-and-name.png
// module id = qsqT
// module chunks = 0